import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=679d96ba&"
import script from "./TeacherEdit.vue?vue&type=script&lang=js&"
export * from "./TeacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports